const VideoCacophonyTypes = {
	ALL_DEVICES: 0,
	TEACHER_DEVICE: 6,
}

const VideoStreamModeTypes = {
	ALL_DEVICES: 1,
	TEACHER_DEVICE: 2,
	STUDENT_PACED: 3,
}

const cacophonyToStream = {
	[VideoCacophonyTypes.ALL_DEVICES]: VideoStreamModeTypes.ALL_DEVICES,
	[VideoCacophonyTypes.TEACHER_DEVICE]: VideoStreamModeTypes.TEACHER_DEVICE,
}

const cacophonyTypeToStreamMode = cacophonyType =>
	cacophonyToStream[cacophonyType] || VideoStreamModeTypes.ALL_DEVICES

export { VideoCacophonyTypes, VideoStreamModeTypes, cacophonyTypeToStreamMode }
